import { TLegalList } from 'shared/types/legalPages.interface';

export const PrivacyPolicyLists: TLegalList = {
  InformationWeCollect: [
    {
      title: 'Account Information:',
      description: 'Name, username, email address, password, and any profile details you provide.',
    },
    {
      title: 'Usage Information:',
      description: 'IP address, browser type, device information, access times, and pages viewed.',
    },
    {
      title: 'Cookies and Analytics:',
      description:
        'Data collected through cookies and similar technologies for performance and usage analysis.',
    },
    {
      title: 'Content:',
      description:
        'Debates you create, join, or stream, including video, audio, chat, and any uploaded materials.',
    },
    {
      title: 'Payment Information:',
      description:
        'If you make purchases, we may collect payment details through our third-party payment processors.',
    },
    {
      title: 'Communications:',
      description:
        'Records of your correspondence with us, including support requests or feedback.',
    },
  ],
  HowWeUseInformation: [
    {
      description: 'Provide, operate, and improve our Services.',
    },
    {
      description: 'Allow you to access debates, streaming, chat, and related features.',
    },
    {
      description: 'Personalize your experience and recommend relevant content.',
    },
    {
      description: 'Conduct analytics and monitor usage trends.',
    },
    {
      description: 'Communicate with you about updates, security, or service-related matters.',
    },
    {
      description: 'Process payments and prevent fraud.',
    },
    {
      description: 'Comply with legal obligations.',
    },
  ],
  SharingOfInformation: [
    {
      title: 'Service Providers:',
      description: `With trusted vendors who help us operate the platform, such as hosting providers, 
        analytics services, video streaming infrastructure, and payment processors.`,
    },
    {
      title: 'Legal Compliance:',
      description: 'If required by law, regulation, or legal process.',
    },
    {
      title: 'Business Transfers:',
      description: 'In connection with a merger, acquisition, or sale of assets.',
    },
    {
      title: 'With Your Consent:',
      description:
        'When you choose to share information (e.g., public debate streams or chat participation).',
    },
  ],
  CookiesAndTracking: [
    {
      description: 'Keep you logged in.',
    },
    {
      description: 'Remember preferences.',
    },
    {
      description: 'Measure performance and usage.',
    },
    {
      description: 'Provide analytics through services such as Google Analytics.',
    },
  ],
  YourRights: [
    {
      title: 'Access:',
      description: 'Request a copy of the personal information we hold about you.',
    },
    {
      title: 'Deletion:',
      description: 'Request that we delete your personal information.',
    },
    {
      title: 'Correction:',
      description: 'Ask us to update or correct inaccuracies.',
    },
    {
      title: 'Opt-Out of Sale/Sharing:',
      description: `You can opt out of any "sale" or "sharing" of personal data as defined under 
        applicable law (note: we do not sell personal data).`,
    },
    {
      title: 'Non-Discrimination:',
      description: 'We will not discriminate against you for exercising your privacy rights.',
    },
  ],
};
